<div class="pnl-settings-categories">
  <header>
    <a [routerLink]="['/app/configuracao']" class="back">Configurações</a>
    <h1>Departamentos</h1>
  </header>

  <form [formGroup]="settingsFrm" (ngSubmit)="onSubmit()" novalidate>
    <section>
      <div class="noselect">
        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
          <mat-tree-node
            *matTreeNodeDef="let node"
            matTreeNodeToggle
            matTreeNodePadding
            (dragover)="handleDragOver($event, node)"
            (dragend)="handleDragEnd($event)"
            (drop)="handleDrop($event, node)"
            [ngClass]="getStyle(node)"
          >
            <button type="button" class="btn-expand">
              <mat-icon>remove</mat-icon>
            </button>
            <span
              class="checklist-leaf-node"
              [draggable]="node.level > 0"
              (dragstart)="handleDragStart($event, node)"
            >
              <figure *ngIf="node.level == 0">
                <img [src]="node.icon" *ngIf="node.icon != ''" />
                <fa-icon *ngIf="node.icon == ''" [icon]="faImage"></fa-icon>
              </figure>
              <span
                class="nodeContent"
                [ngClass]="{ 'drag-start': dragNode === node }"
              >
                {{ node.item }}
              </span>
            </span>
            <button
              class="btn btn-primary-outline"
              type="button"
              *ngIf="node.level == 0 && node.id != null && node.id > 0"
              (click)="addIcon(node)"
            >
              <mat-icon>add_a_photo</mat-icon>
            </button>
            <button
              *ngIf="node.owner"
              class="btn btn-warning-outline"
              type="button"
              (click)="editText(node)"
            >
              <mat-icon>edit_note</mat-icon>
            </button>
            <button
              class="btn btn-primary-outline"
              type="button"
              (click)="addNewItem(node)"
            >
              <mat-icon>add</mat-icon>
            </button>
            <button
              class="btn btn-danger-outline"
              type="button"
              (click)="deleteItem(node)"
            >
              <mat-icon>delete_outline</mat-icon>
            </button>
          </mat-tree-node>

          <mat-tree-node
            *matTreeNodeDef="let node; when: hasChild"
            matTreeNodePadding
            (dragover)="handleDragOver($event, node)"
            (dragend)="handleDragEnd($event)"
            (drop)="handleDrop($event, node)"
            [ngClass]="getStyle(node)"
          >
            <button
              type="button"
              matTreeNodeToggle
              [attr.aria-label]="'toggle ' + node.item"
              class="btn-expand"
            >
              <mat-icon class="mat-icon-rtl-mirror">
                {{
                  treeControl.isExpanded(node) ? "expand_more" : "chevron_right"
                }}
              </mat-icon>
            </button>
            <span
              class="checklist-leaf-node"
              [draggable]="node.level > 0"
              (dragstart)="handleDragStart($event, node)"
            >
              <figure *ngIf="node.level == 0">
                <img [src]="node.icon" *ngIf="node.icon != ''" />
                <fa-icon *ngIf="node.icon == ''" [icon]="faImage"></fa-icon>
              </figure>
              <span
                class="nodeContent"
                [ngClass]="{ 'drag-start': dragNode === node }"
              >
                {{ node.item }}
              </span>
            </span>
            <button
              class="btn btn-primary-outline"
              type="button"
              *ngIf="node.level == 0 && node.id != null && node.id > 0"
              (click)="addIcon(node)"
            >
              <mat-icon>add_a_photo</mat-icon>
            </button>
            <button
              *ngIf="node.owner"
              class="btn btn-warning-outline"
              type="button"
              (click)="editText(node)"
            >
              <mat-icon>edit_note</mat-icon>
            </button>
            <button
              class="btn btn-primary-outline"
              type="button"
              (click)="addNewItem(node)"
            >
              <mat-icon>add</mat-icon>
            </button>
          </mat-tree-node>
        </mat-tree>

        <span #emptyItem></span>

        <div class="mt30">
          <button (click)="newCat()" type="button" class="btn btn-primary">
            Adicionar nova categoria
          </button>
        </div>
      </div>
    </section>
  </form>

  <div *ngIf="showModal" class="modal" [class.open]="openModal">
    <div
      class="modal-content modal-medium"
      [class.modal-content-desc]="modalType != 'add-icon'"
      [class.modal-content-image]="modalType == 'add-icon'"
    >
      <header>
        <span *ngIf="modalType == 'new'"
          >Adicionar nova subcategoria em
          <strong>{{ nodeSelected.item }}</strong></span
        >
        <span *ngIf="modalType == 'edit'"
          >Renomear
          {{ nodeSelected.level == 0 ? "categoria" : "subcategoria" }}</span
        >
        <span *ngIf="modalType == 'add-icon'"
          >Adicionar um ícone para categoria</span
        >
        <span *ngIf="modalType == 'new-cat'">Adicionar nova categoria</span>
        <a (click)="closeModal()"><mat-icon>clear</mat-icon></a>
      </header>
      <section>
        <div *ngIf="modalType != 'add-icon'">
          <label>Descrição</label>
          <input
            type="text"
            [(ngModel)]="categorySelected"
            class="form-control"
          />
        </div>
        <div *ngIf="modalType == 'add-icon'">
          <div
            ng2FileDrop
            [uploader]="uploader"
            (fileOver)="fileOverBase($event)"
            [ngClass]="{ 'nv-file-over': hasBaseDropZoneOver }"
            class="drag-zone-upload"
          >
            <div
              *ngIf="
                (uploader.queue && uploader.queue.length > 0) || imageIcon != ''
              "
              class="image-cover"
            >
              <div class="image-cover-limit">
                <img [src]="imageIcon" *ngIf="imageIcon != ''" />
                <img
                  *ngFor="let item of uploader.queue; let i = index"
                  src=""
                  imgPreview
                  [image]="item?._file"
                />
              </div>
            </div>

            <div
              *ngIf="
                uploader.queue && uploader.queue.length == 0 && imageIcon == ''
              "
              class="image-cover"
            >
              <fa-icon [icon]="faImage"></fa-icon>

              <h6>Adicione o ícone</h6>
            </div>

            <input
              id="fileUploader"
              #fileUploader
              type="file"
              ng2FileSelect
              [uploader]="uploader"
              class="dnone"
            />

            <div class="image-cover">
              <button
                (click)="fileUploader.click()"
                type="button"
                class="btn btn-primary"
              >
                Adicionar ícone
              </button>
            </div>
          </div>
        </div>
      </section>
      <footer>
        <button
          (click)="closeModal()"
          type="button"
          class="btn btn-primary-outline"
        >
          CANCELAR
        </button>
        <button (click)="okModal()" type="button" class="btn btn-primary">
          {{ modalType == "add-icon" ? "SALVAR" : "OK" }}
        </button>
      </footer>
    </div>
  </div>

  <div class="actions" [class.dflex]="changed">
    <span>Salvar as alterações</span>
    <div>
      <button
        type="button"
        (click)="onCancel()"
        class="btn btn-primary-outline"
      >
        Cancelar
      </button>
      <button type="button" (click)="onSubmit()" class="btn btn-primary">
        Salvar
      </button>
    </div>
  </div>

  <div class="loading" *ngIf="loading">
    <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
      <div class="ldio-ns36390yc">
        <div></div>
      </div>
    </div>
  </div>
</div>
